// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { groupsRequested } from '@coa/app/shared/add-to-group-dialog/modules/add-to-group/store/add-to-group.actions';
import { NgxSpinnerService } from 'ngx-spinner';
import { selectIsAdding } from '@coa/app/shared/add-to-group-dialog/modules/add-to-group/store/add-to-group.selectors';

@Component({
  selector: 'coa-add-to-group',
  templateUrl: './add-to-group.component.html',
  styleUrls: ['./add-to-group.component.scss'],
})
export class AddToGroupComponent implements OnInit, OnChanges {
  @Input() clientId: number;
  @Input() selections: number[];
  @Output() showCreateGroup = new EventEmitter<void>();

  constructor(
    private store$: Store,
    private spinnerService: NgxSpinnerService,
  ) {
  }

  ngOnInit(): void {
    this.store$.pipe(select(selectIsAdding))
      .subscribe((value) => {
        if (value) {
          this.spinnerService.show();
        } else {
          this.spinnerService.hide();
        }
      });
  }

  ngOnChanges(): void {
    if (this.clientId) {
      this.store$.dispatch(groupsRequested({clientId: this.clientId}));
    }
  }
}
